import * as actionTypes from '../../constants/actions';

import { fetchCommonRoom } from './commonRoom.action';
import { fetchAnnouncements } from './announcements.action';

export const fetchSpaceContent =
  ({ classRoom, reset = false, latest = false, tagId }) =>
  async (dispatch) => {
    await Promise.all([
      dispatch(
        fetchCommonRoom({
          classRoom,
          reset,
          tagId,
          latest,
          shouldFetchTags: true,
        })
      ),
      dispatch(fetchAnnouncements({ classRoom, reset, tagId, latest })),
    ]);
  };

export const selectFeedType =
  ({ feedType }) =>
  async (dispatch) => {
    dispatch({
      type: actionTypes.SPACE_SELECT_FEED_TYPE,
      payload: { feedType },
    });
  };

export { fetchCommonRoom, fetchAnnouncements };
